import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="w-full bg-white px-5 py-12 sm:py-20" data-id="element-157" data-mp="22lezoe7p17k6">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-158" data-mp="22mq66lsiwtez">
        <span className="mb-5 inline-block rounded-full border border-sage/40 bg-sage/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-dark-green" data-id="element-159" data-mp="2ge4t33pjxerb">
          📦 Lo que incluye el sistema
        </span>
        <h2 className="font-serif-display text-3xl font-bold leading-tight text-slate sm:text-5xl" data-id="element-160" data-mp="26kxovm6js4st">
          Sistema Nutri-Pro Completo™
        </h2>
        <p className="mt-5 text-base font-medium text-dark-green sm:text-lg" data-id="element-161" data-mp="2zbfmi7oi5dyu">
          El sistema digital de consulta nutricional más completo disponible para profesionales de
          toda LATAM.
        </p>
        <div className="mx-auto mt-6 h-px w-16 bg-sage/40" data-id="element-162" data-mp="ugqbttfmstem" />
        <p className="mt-6 text-sm leading-relaxed text-slate/70 sm:text-base" data-id="element-163" data-mp="pglrttfilgjn">
          460 páginas de contenido clínico basado en evidencia, organizado en 6 tomos profesionales
          y 4 bonos especializados. Diseñado para que cada consulta sea más ordenada, más segura y
          más efectiva.
        </p>
      </motion.div>
    </section>;
}